"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SignalStrength = require("../SignalStrength/SignalStrength.styled");
var _SignalIcon = _interopRequireDefault(require("../SignalStrength/SignalIcon"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");
var _metrics = require("@studio/metrics");
var _useTranslate2 = require("../../locales/useTranslate");
var _templateObject;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StyledItemWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n"])), function (_ref) {
  var bottomRight = _ref.bottomRight;
  return bottomRight && "\n    margin-left: auto;\n    position: absolute;\n    right: 4px;\n    bottom: 4px;\n    z-index: 2;\n  ";
});
var valueUnavailable = {};
function SignalStrengthToolTip(_ref2) {
  var attendeeId = _ref2.attendeeId,
    description = _ref2.description,
    mode = _ref2.mode,
    toolTipId = _ref2.toolTipId;
  var sourceNetworkHealth = (0, _reactRedux.useSelector)(function (state) {
    var _state$attendeeNetwor;
    var metrics = ((_state$attendeeNetwor = state.attendeeNetworkHealth) === null || _state$attendeeNetwor === void 0 ? void 0 : _state$attendeeNetwor[attendeeId]) || valueUnavailable;
    return {
      networkQuality: metrics.networkQuality || 'NA',
      videoPacketLoss: metrics.videoPacketLoss || 0,
      videoJitter: metrics.videoJitter || '',
      videoLatency: metrics.videoLatency || '',
      videoFrame: metrics.videoFrame || '',
      receivedFrame: metrics.receivedFrame || 'NA'
    };
  }, _reactRedux.shallowEqual);
  return /*#__PURE__*/_react["default"].createElement(_SignalStrength.StyledToolTip, {
    delay: {
      show: 300,
      hide: 100
    },
    id: "tooltip_".concat(toolTipId),
    target: toolTipId,
    placement: 'top',
    modifiers: [{
      name: 'preventOverflow',
      options: {
        boundary: 'window'
      }
    }],
    mode: mode
  }, sourceNetworkHealth.networkQuality === 'NA' && /*#__PURE__*/_react["default"].createElement(_SignalStrength.TooltipContent, {
    className: mode
  }, /*#__PURE__*/_react["default"].createElement(_SignalStrength.NetworkItem, {
    className: mode
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "left"
  }, /*#__PURE__*/_react["default"].createElement(_SignalIcon["default"], {
    toolTipId: toolTipId,
    health: sourceNetworkHealth.networkQuality,
    tooltipShown: true
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, /*#__PURE__*/_react["default"].createElement("b", null, description))), /*#__PURE__*/_react["default"].createElement(_SignalStrength.NoConnectivityMetricsMsg, {
    className: mode
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "left"
  }, "Turn on the camera to view network details."))), sourceNetworkHealth.networkQuality !== 'NA' && /*#__PURE__*/_react["default"].createElement(_SignalStrength.TooltipContent, {
    className: mode
  }, /*#__PURE__*/_react["default"].createElement(_SignalStrength.NetworkItem, {
    className: mode
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "left"
  }, /*#__PURE__*/_react["default"].createElement(_SignalIcon["default"], {
    toolTipId: toolTipId,
    health: sourceNetworkHealth.networkQuality,
    tooltipShown: true
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, description)), /*#__PURE__*/_react["default"].createElement(_SignalStrength.NetworkItem, {
    className: mode
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "left"
  }, /*#__PURE__*/_react["default"].createElement(_SignalStrength.StyledNetworkIcon, {
    className: mode,
    icon: _freeSolidSvgIcons.faLinkSlash
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, /*#__PURE__*/_react["default"].createElement("b", null, "Packet Loss:"), " ", sourceNetworkHealth.videoPacketLoss, "%")), /*#__PURE__*/_react["default"].createElement(_SignalStrength.NetworkItem, {
    className: mode
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "left"
  }, /*#__PURE__*/_react["default"].createElement(_SignalStrength.StyledNetworkIcon, {
    className: mode,
    icon: _freeSolidSvgIcons.faWaveSquare
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, /*#__PURE__*/_react["default"].createElement("b", null, "Jitter:"), " ", sourceNetworkHealth.videoJitter, "ms")), /*#__PURE__*/_react["default"].createElement(_SignalStrength.NetworkItem, {
    className: mode
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: "left"
  }, /*#__PURE__*/_react["default"].createElement(_SignalStrength.StyledNetworkIcon, {
    className: mode,
    icon: _freeSolidSvgIcons.faStopwatch
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, /*#__PURE__*/_react["default"].createElement("b", null, "Latency:"), " ", sourceNetworkHealth.videoLatency, "ms")), /*#__PURE__*/_react["default"].createElement(_SignalStrength.NetworkItem, null, /*#__PURE__*/_react["default"].createElement("section", {
    className: "left"
  }, /*#__PURE__*/_react["default"].createElement(_SignalStrength.StyledNetworkIcon, {
    className: mode,
    icon: _proSolidSvgIcons.faVideoArrowUpRight
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, /*#__PURE__*/_react["default"].createElement("b", null, "Sending:"), " ", sourceNetworkHealth.videoFrame)), sourceNetworkHealth.receivedFrame && sourceNetworkHealth.receivedFrame !== 'NA' && /*#__PURE__*/_react["default"].createElement(_SignalStrength.NetworkItem, null, /*#__PURE__*/_react["default"].createElement("section", {
    className: "left"
  }, /*#__PURE__*/_react["default"].createElement(_SignalStrength.StyledNetworkIcon, {
    className: mode,
    icon: _proSolidSvgIcons.faVideoArrowDownLeft
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: "".concat(mode, " right")
  }, /*#__PURE__*/_react["default"].createElement("b", null, "Receiving:"), " ", sourceNetworkHealth.receivedFrame))));
}

/**
 * Component that displays an attendee's signal strength (& its metadata)
 * @param attendeeId
 * @param mode
 * @param isLightTheme
 * @param showTextLabel
 * @param width
 * @returns {JSX.Element|null}
 * @constructor
 */
var SignalStrengthV2 = function SignalStrengthV2(_ref3) {
  var attendeeId = _ref3.attendeeId,
    mode = _ref3.mode,
    _ref3$isLightTheme = _ref3.isLightTheme,
    isLightTheme = _ref3$isLightTheme === void 0 ? false : _ref3$isLightTheme,
    _ref3$showTextLabel = _ref3.showTextLabel,
    showTextLabel = _ref3$showTextLabel === void 0 ? false : _ref3$showTextLabel,
    _ref3$width = _ref3.width,
    width = _ref3$width === void 0 ? null : _ref3$width,
    _ref3$bottomRight = _ref3.bottomRight,
    bottomRight = _ref3$bottomRight === void 0 ? true : _ref3$bottomRight;
  var toolTipId = "network-info-".concat(attendeeId);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    tooltipOpen = _useState2[0],
    setTooltipOpen = _useState2[1];
  var _useTranslate = (0, _useTranslate2.useTranslate)(),
    translate = _useTranslate.translate;
  var networkQualityText = {
    poor: translate('PoorNetwork_Popover'),
    good: translate('GoodNetwork_Popover'),
    excellent: translate('ExcellentNetwork_Popover'),
    unavailable: translate('NoNetworkData_Popover')
  };
  var _useNetworkhealthPage = (0, _metrics.useNetworkhealthPageActionsApi)(),
    userViewsNetworkHealthTooltip = _useNetworkhealthPage.userViewsNetworkHealthTooltip;
  var handleMouseEnter = (0, _react.useCallback)(function () {
    setTooltipOpen(true);
    userViewsNetworkHealthTooltip({
      meetingUserId: attendeeId
    });
  }, [attendeeId, userViewsNetworkHealthTooltip]);
  var handleMouseLeave = (0, _react.useCallback)(function () {
    setTooltipOpen(false);
  }, []);
  var networkQuality = (0, _reactRedux.useSelector)(function (state) {
    var _state$attendeeNetwor2;
    return (_state$attendeeNetwor2 = state.attendeeNetworkHealth) === null || _state$attendeeNetwor2 === void 0 || (_state$attendeeNetwor2 = _state$attendeeNetwor2[attendeeId]) === null || _state$attendeeNetwor2 === void 0 ? void 0 : _state$attendeeNetwor2.networkQuality;
  });
  if (!networkQuality) {
    return null;
  }
  var inlineTooltipText = networkQualityText[networkQuality] || networkQualityText.unavailable;
  if (width && width <= 1068) {
    inlineTooltipText = inlineTooltipText.replace('connection', '').trim();
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, /*#__PURE__*/_react["default"].createElement(StyledItemWrapper, {
    bottomRight: bottomRight
  }, /*#__PURE__*/_react["default"].createElement(_SignalStrength.IconsWrapper, null, /*#__PURE__*/_react["default"].createElement(_SignalStrength.IconTextWrapper, null, /*#__PURE__*/_react["default"].createElement(_SignalIcon["default"], {
    toolTipId: toolTipId,
    health: networkQuality,
    isLightTheme: isLightTheme,
    attendeeId: attendeeId,
    trackMouseEnter: false
  }), showTextLabel && /*#__PURE__*/_react["default"].createElement(_SignalStrength.NetworkLabel, null, inlineTooltipText)), tooltipOpen ? /*#__PURE__*/_react["default"].createElement(SignalStrengthToolTip, {
    attendeeId: attendeeId,
    description: networkQualityText[networkQuality] || networkQualityText.unavailable,
    mode: mode,
    toolTipId: toolTipId
  }) : null)));
};
SignalStrengthToolTip.propTypes = {
  attendeeId: _propTypes["default"].string.isRequired,
  mode: _propTypes["default"].string.isRequired,
  toolTipId: _propTypes["default"].string.isRequired
};
SignalStrengthV2.propTypes = {
  attendeeId: _propTypes["default"].string.isRequired,
  mode: _propTypes["default"].string.isRequired,
  isLightTheme: _propTypes["default"].bool,
  showTextLabel: _propTypes["default"].bool,
  width: _propTypes["default"].any
};
var _default = exports["default"] = SignalStrengthV2;